import { render, staticRenderFns } from "./DemandFilters.vue?vue&type=template&id=64523782&"
import script from "./DemandFilters.vue?vue&type=script&lang=js&"
export * from "./DemandFilters.vue?vue&type=script&lang=js&"
import style0 from "./DemandFilters.vue?vue&type=style&index=0&id=64523782&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports